module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusive-02-991a5d7cf28abe660871066fb30f4c56.png";